module.exports = "/_next/static/images/buyers_4-db877b36867f98ee947bdca306941f8e.png";